"use client";

import * as SelectPrimitive from "@radix-ui/react-select";

const Select = SelectPrimitive.Root;
const SelectGroup = SelectPrimitive.Group;
const SelectValue = SelectPrimitive.Value;

const SelectItemText = SelectPrimitive.ItemText;
const SelectItemPrimitive = SelectPrimitive.Item;
const SelectItemIndicator = SelectPrimitive.ItemIndicator;

export {
  Select,
  SelectGroup,
  SelectItemPrimitive,
  SelectItemIndicator,
  SelectItemText,
  SelectValue,
};
